
import { User } from "@nextui-org/react";
import { NavLink } from "react-router-dom";
import { UserContext } from "utils/context";
import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Upload from "components/Upload";
import { Modal } from "@mui/material";
import { FaUser } from "react-icons/fa";
import { GiHamburgerMenu, GrClose } from "react-icons/gi";

const UserIcon = ({ user }) => {
    const src = "https://www.pngkit.com/png/full/128-1280585_user-icon-fa-fa-user-circle.png";

    return <img
        src={`${process.env.PUBLIC_URL + '/icons/profile.svg'}`}
        alt="more"
        width={45}
        height={45}
        className="icon"
    />
}

const DisplayNav = ({ role, setVisible }) => {
    return <>
        {([1, 2, 3, 4, 5].includes(role)) && <NavLink to="/">
            Dépôt
        </NavLink>}

        {([0].includes(role)) && <NavLink to="/">
            Login
        </NavLink>}

        {([1, 4, 5].includes(role)) && <NavLink to="/explorer">
            Explorateur
        </NavLink>}

        {([2, 3, 4].includes(role)) && <NavLink to="/panel">
            Documents
        </NavLink>}

        {([2, 3, 4].includes(role)) && <NavLink to="/client">
            Clients
        </NavLink>}

        {([3, 4].includes(role)) && <NavLink to="/referent">
            Référents
        </NavLink>}
    </>
}

const Header = () => {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth)
    const [user, setUser] = useContext(UserContext);
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    const [toggleMenu, setToggleMenu] = useState(false)

    useEffect(() => {
        const changeWidth = () => {
          setScreenWidth(window.innerWidth);
        }
    
        window.addEventListener('resize', changeWidth)

        return () => {
            window.removeEventListener('resize', changeWidth)
        }

      }, [])

    const disconnect = () => {
        setUser(null);
        navigate("/login");
    }

    if (screenWidth < 800 && false) {
        return <header>

            <GiHamburgerMenu onClick={() => setToggleMenu(old => !old)} />
        </header>
    }

    return <header>

        <div>
        </div>

        <nav>
            <DisplayNav setVisible={setVisible} role={user ? user.role?.id : 0} />
        </nav>


        <div>
            {(user) && <>
                <UserIcon user={user} />

                <button className={"error"} onClick={disconnect}>Se déconnecter</button>
            </>}
        </div>
    </header>
}

export default Header;